import { Formik, useFormikContext } from 'formik'
import { motion } from "framer-motion"
import { ViewStepper, BookingSummary, FormContent, FormHeader, CurrentView, ViewListener } from '~/components'
import { default as SelectMethod } from './SelectMethod'
import { default as ValidatePhone } from './ValidatePhone'
import { default as InputEmail } from './InputEmail'
import { default as ValidateEmail } from './ValidateEmail'
import { default as InputName } from './InputName'
import { default as AcceptTerms } from './AcceptTerms'
import { default as SocialAddPhone } from './SocialAddPhone'
import { default as SocialValidatePhone } from './SocialValidatePhone'
import { default as ConfirmExistingProfile } from './ConfirmExistingProfile'
import { default as SocialSelectEmail } from './SocialSelectEmail'
import { DebugListener } from '~/components/DebugPanel'
import classnames from 'classnames/bind'
import * as common from '~/config/common.module.css'
import { useTranslation } from 'react-i18next'

const cx = classnames.bind(common)

const OtpFlow = ({fullscreen}) => {
  const { t } = useTranslation()
  const { values } = useFormikContext()
  const inEditMode = !isNaN(values.bookingId) && values.bookingId > 0

  const views = [
    { id: 'selectMethod', component: SelectMethod },
    { id: 'validatePhone', component: ValidatePhone },
    { id: 'inputEmail', component: InputEmail },
    { id: 'validateEmail', component: ValidateEmail },
    { id: 'inputName', component: InputName },
    { id: 'acceptTerms', component: AcceptTerms },
    { id: 'socialAddPhone', component: SocialAddPhone },
    { id: 'socialValidatePhone', component: SocialValidatePhone },
    { id: 'confirmExistingProfile', component: ConfirmExistingProfile },
    { id: 'socialSelectEmail', component: SocialSelectEmail },
  ]

  const initialValues = {
    dialCode: '+46',
    phone: '',
    phoneCode: '',
    email: '',
    maskedEmail: '',
    emailCode: '',
    firstName: '',
    lastName: '',
    externalEmail: '',
    existingUserName: '',
    existingUserEmail: '',
    marketingOptIn: false,
    termsAndConditions: false,
    shouldConsentToMarketing: true,
    shouldConsentToTermsAndConditions: true,
  }

  return (
    <div layout transition={{duration:.18}} className={cx(common.widgetWrapper, {fullscreen:fullscreen})}>
      {fullscreen && (
        <FormContent>
          <FormHeader>{inEditMode ? t('edit-your-trip') : t('your-trip')}</FormHeader>
          <BookingSummary values={values} showHow />
        </FormContent>
      )}
      <ViewStepper views={views}>
        {({ View }) => {
          return (
            <Formik initialValues={initialValues} validationSchema={View?.validationSchema || null}>
              <>
                <CurrentView fullscreen={fullscreen}/>
                <ViewListener />
                {process.env.NODE_ENV !== 'production' && <DebugListener id="otp" />}
              </>
            </Formik>
          )
        }}
      </ViewStepper>
    </div>
  )
}

OtpFlow.validationSchema = null

export default OtpFlow
